// extracted by mini-css-extract-plugin
export default {"divBody":"style_divBody__47-60","iconWrap":"style_iconWrap__aluNY","groupItemIcon":"style_groupItemIcon__NAD4C"};